import type {ReactNode} from 'react';
import type {CssProperties} from '@sail/ui';
import {useSelector} from 'src/v2/state/store';
import {Button} from 'src/v2/components/common';
import type {TextType} from 'src/v2/components/common/Text';

interface BrandedButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  css?: CssProperties;
  textCss?: CssProperties;
  textType?: TextType;
  children: ReactNode;
}

export const BrandedButton = ({
  onClick,
  disabled,
  loading,
  css,
  textCss,
  textType,
  children,
}: BrandedButtonProps) => {
  const buttonColor = useSelector(
    (state) => state.merchantBranding.buttonColor,
  );

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      css={{backgroundColor: buttonColor, ...css}}
      textCss={textCss}
      textType={textType}
    >
      {children}
    </Button>
  );
};
